import { useRouterContext, useLink } from "@refinedev/core";

import classes from "./DocumentDisplay.module.css";
import { deleteDoc, getDocument } from "api/admin";
import { DocumentDisplay } from "components/Panel/Admin/Documents/DocumentDisplay";
import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export const AdminDocsView = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { id } = useParams<{ id: string }>();

    const [doc, setDoc] = useState<any>(null);

    useEffect(() => {
        (async () => {
            setLoading(true);
            const doc = await getDocument(id ?? "");
            setLoading(false);
            setDoc(doc.data);
        })();
    }, [id]);

    return (
        <Spin spinning={loading} indicator={<LoadingOutlined style={{ fontSize: 48, color: "white" }} spin />}>
            <DocumentDisplay
                title={doc?.title}
                content={doc?.content}
                onEdit={() => navigate(`/admin/docs/${id}/edit`)}
                onDelete={async () => {
                    await deleteDoc(id ?? "");
                    navigate('/admin');
                }}
            />
        </Spin>
    );
};
